<article class="card" [class]="'card--' + state()" [attr.data-cy]="qaKeys.IssueCard" [attr.data-state]="state()">
  <div class="card__main">
    <div class="card__identity">
      <h3 class="card__label" [attr.data-cy]="qaKeys.IssueCardLabel">{{ label() }}</h3>
      @for (service of serviceChips(); track service.name) {
        <span
          class="card__service"
          [class]="'card__service--' + service.state"
          [attr.data-cy]="qaKeys.IssueCardService">
          <span aria-hidden="true">{{ service.name }}</span>
          <span class="card__service-state">{{ service.accessibleName }}</span>
        </span>
      }
    </div>
    <fv-status-pill [state]="state()" />
  </div>
  <div class="card__meta">
    <span>{{ copy.lastChecked }} {{ lastChecked() }}</span>
    @if (isUnavailable() && since()) {
      <span class="card__since">{{ sinceLabel() }}</span>
    }
  </div>
  @if (error()) {
    <p class="card__error" [title]="error()">{{ error() }}</p>
  }
</article>
